export default __webpack_public_path__ + "static/media/gmdLogo.e52a4ed3.JPG";